import React, { Component } from 'react';
import { connect } from 'react-redux';
import Loading from './Global/Loading';
import { Link } from 'react-router-dom';

import * as actions from '../actions';

class SelectSite extends Component {
  shouldComponentUpdate(nextProps) {
    const { sites, selectedSite } = nextProps;
    const differentSites        = sites        !== this.props.sites;
    const differentSelectedSite = selectedSite !== this.props.selectedSite;

    return differentSites || differentSelectedSite;
  }

  getSites() {
    const sites = this.props.sites;
    if (!sites) return false;

    return sites.map(siteUrl => {
      return (
        <Link
          key={siteUrl}
          className="collection-item"
          to=""
          onClick={event => {
            event.preventDefault();
            this.props.selectSite(siteUrl);
            this.props.history.push('/dashboard');
          }}>
          {siteUrl}
        </Link>
      );
    });
  }

  renderSites() {
    const siteList = this.getSites();

    if (!siteList) {
      return <Loading />;
    }

    if (siteList.length === 0) {
      return (
        <div>
          <p className="col s12">
            This Google account doesn't have any verified sites. Please verify them in Google Search Console
            or signing with another Google account.
          </p>
          <a className="white-text col" href="/auth/google">
            <button className="btn z-depth-3">Sign in another account</button>
          </a>
        </div>
      );
    }

    return (
      <div>
        <p className="col s12">Choose a site below:</p>
        <div className="collection col s12">{siteList}</div>
      </div>
    );
  }

  componentDidMount() {
    this.props.fetchSites();
  }

  render() {
    return (
      <div className="container">
        <div className="row">{this.renderSites()}</div>
      </div>
    )
  }
}

function mapStateToProps({ sites, selectedSite, isDataPresent, auth }) {
  return { sites, selectedSite, isDataPresent, auth };
}

export default connect(mapStateToProps, actions)(SelectSite);



// WEBPACK FOOTER //
// ./src/components/SelectSite.js